import { Alert, Box, CircularProgress, Typography } from '@mui/material'

import { FC, useContext, useMemo } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { TrailMap as TrailMapComponent } from '../components/TrailMap/TrailMap'
import { TrailSystemContext } from '../providers/TrailSystem/TrailSystem'

export const TrailMap: FC = () => {
  const { trailId } = useParams<{ trailId: string }>()
  const trailSystemContext = useContext(TrailSystemContext)

  // Validate trailId parameter
  if (!trailId || isNaN(Number(trailId))) {
    return <Navigate to="/" replace />
  }

  const trailIdNum = Number(trailId)

  // Find the trail from the existing TrailSystem context data
  const trail = useMemo(() => {
    if (!trailSystemContext.trailSystems || trailSystemContext.trailSystems.length === 0) {
      return null
    }

    // Search through all trail systems to find the specific trail
    for (const trailSystem of trailSystemContext.trailSystems) {
      if (trailSystem.trails) {
        const foundTrail = trailSystem.trails.find((t) => t.id === trailIdNum)
        if (foundTrail) {
          return foundTrail
        }
      }
    }
    return null
  }, [trailSystemContext.trailSystems, trailIdNum])

  if (trailSystemContext.query?.isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    )
  }

  if (!trail) {
    return (
      <Box p={3}>
        <Alert severity="error">Trail not found. Please check the trail ID and try again.</Alert>
      </Box>
    )
  }

  return (
    <Box p={3}>
      <Typography variant="h4" component="h1" gutterBottom>
        {trail.name} - Trail Map
      </Typography>

      <Typography variant="body1" color="text.secondary" paragraph>
        Interactive map showing the trail path and current obstructions. Click on obstruction markers for details.
      </Typography>

      <Box mt={3}>
        <TrailMapComponent trailId={trailIdNum} trail={trail} />
      </Box>
    </Box>
  )
}
